import { ConfirmProvider } from "material-ui-confirm";
import { SnackbarProvider } from "notistack";
import React from "react";
import { useRoutes } from "react-router";

import { CssBaseline, ThemeProvider } from "@mui/material";

import PageLoading from "./components/PageLoading";
import { ContextProvider } from "./dataStore/context";
import routes from "./routes/routes";
import theme from "./theme/theme";

const App = () => {
  const routing = useRoutes(routes);

  return (
    <ContextProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          hideIconVariant={false}
          dense={false}
        >
          <ConfirmProvider>
            <React.Suspense fallback={<PageLoading />}>
              {routing}
            </React.Suspense>
          </ConfirmProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </ContextProvider>
  );
};

export default App;
